import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from '@nuxtjs/composition-api';

export interface PlanType {
  name: string;
  value: string;
}

export interface TogglePlansProps {
  left: PlanType;
  right: PlanType;
  checked?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TogglePlans',
  props: {
    left: null,
    right: null,
    checked: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'toggle', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  left: PlanType;
  right: PlanType;
  checked?: boolean;
};



onMounted(() => {
  isToggled.value = props.checked || false;
});

const isToggled = ref(false);

function toggle() {
  isToggled.value = !isToggled.value;
  emit('toggle', isToggled.value ? props.right.value : props.left.value);
}

return { __sfc: true,props, emit, isToggled, toggle }
}

})